export default __webpack_public_path__ + "static/media/paper-plane.2fd57245.png";